module.exports = __webpack_public_path__ + "img/fig_dofa_3.1cd8fc31.svg";